import moment from 'moment';

class File {
  static get TYPE() {
    return 'file';
  }

  static fromAPIResponse(res) {
    let { createdOn = null } = res.attributes;
    if (createdOn) {
      createdOn = moment(createdOn);
    }
    return Object.assign(new File(), res.attributes, {
      id: res.id,
      createdOn,
    });
  }

  static fromJSON(json) {
    let { createdOn = null } = json.attributes;

    if (createdOn) {
      createdOn = moment(createdOn);
    }

    return Object.assign(new File(), json, {
      createdOn,
    });
  }

  static toAPIRequest(file) {
    return {
      id: file.id,
      type: File.TYPE,
      attributes: { ...file, id: +file.id },
    };
  }

  constructor() {
    this.id = '';
    this.type = 'file';
    this.attributes = {
      name: '',
      status: '',
      createdOn: null,
      createdBy: '',
      previewURL: '',
    };
    this.relationships = null;
    this.links = {
      self: '',
    };
  }
}

export default File;
